import { Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import { AuthProvider } from "./auth/AuthProvider";
import ProtectedRoute from "./auth/ProtectedRoute";
import AdminRoute from "./auth/AdminRoute";
import DashboardPage from "./pages/DashboardPage";
import ControlsPage from "./pages/ControlsPage";
import ControlsRankingPage from "./pages/ControlsRankingPage";
import CarsPage from "./pages/CarsPage";
import ShopsPage from "./pages/ShopsPage";
import ShopDetailPage from "./pages/ShopDetailPage";
import UsersPage from "./pages/UsersPage";
import LoginPage from "./pages/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="controls" element={<ControlsPage />} />
            <Route path="controls/rankings" element={<ControlsRankingPage />} />
            <Route path="cars" element={<CarsPage />} />
            <Route path="shops" element={<ShopsPage />} />
            <Route path="shops/:id" element={<ShopDetailPage />} />
            <Route element={<AdminRoute />}>
              <Route path="admin/users" element={<UsersPage />} />
            </Route>
            <Route path="home" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
